import { useEffect, useState } from 'react';

export function useIsCapsLockStatus() {
  const [capsLockOn, setCapsLockOn] = useState<boolean>();

  const handleKeyDown = (event:any) => {
    if (event.getModifierState('CapsLock')) {
      setCapsLockOn(true);
    } else {
      setCapsLockOn(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return capsLockOn;
}
